import React from 'react'
import { Field, ErrorMessage, FieldArray } from 'formik'
import TextError from './TextError.js'

function FieldArrayTechExp(props) {
    const { label, name, ...rest } = props
    return (
        <div>
            <div className="form-group" style={{"margin":"2%"}}>
                <label><strong>{label}</strong></label>
                <FieldArray name={name} {...rest}>
                {fieldArrayProps => {
                  const { push, remove, form } = fieldArrayProps
                  const { values } = form
                  const { dataList } = values

                console.log("dataList",dataList)



                  // console.log('fieldArrayProps', fieldArrayProps)
                  // console.log('Form errors', form.errors)
                  return (
                    <div>
                      {dataList.map((data, index) => (
                        <div key={index}>
                          <Field name={`data[${index}].naceCode`} />
                          <Field name={`data[${index}].edu`} />
                          {index > 0 && (
                            <button type='button' onClick={() => remove(index)}>
                              -
                            </button>
                          )}
                        </div>
                      ))}
                      <button type='button' onClick={() => push('')}>
                        +
                      </button>
                    </div>
                  )
                }}
              </FieldArray>
                <ErrorMessage name={name} component={TextError}/>
            </div>
        </div>
    )
}

export default FieldArrayTechExp